<template>
  <div class="intro-page">
    <!-- PC 端布局 -->
    <div class="intro-pc" v-show="isPC">
      <div class="company-intro-container">
        <!-- 子公司简介列表 -->
        <div class="sub-company-list">
          <!-- 深圳万润科技股份有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>深圳万润科技股份有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                深圳万润科技股份有限公司（证券简称：万润科技，证券代码002654）创立于2002年12月，注册地在深圳市光明区，注册资本8.45亿元，于2012年2月在深交所上市，是国企控股、市场化运作的混合所有制上市公司，公司实控人是湖北省国资委，控股股东为长江产业投资集团。
              </p>
              <p>
                公司早期主要从事LED光源器件封装和LED照明灯具制造，上市后，通过收并购，进入标识照明、照明工程、综合能源管理和新能源、广告传媒等业务。现LED业务已形成集封装-照明-合同能源管理-照明工程设计与施工-智慧城市为一体的中下游产业链协同配套布局，是国内领先的集研发、设计、生产、销售、照明工程设计与施工于一体的综合服务商，聚焦差异化的中高端市场和产品，业务遍布全球主要国家和地区。2022年，公司正式进入半导体存储产业，逐步完善集研发设计、生产测试和销售服务于一体的产业链布局，形成了覆盖消费级、工业级、企业级的存储产品矩阵，为新一代信息技术产业发展奠定坚实基础。
                未来，公司将大力发展以LED、半导体存储为核心的新一代信息技术“主产业”，培育综合能源服务“副产业”，使公司成为新一代信息技术领域具有行业影响力的科技型创新型上市公司。
              </p>
            </div>
          </section>

          <!-- 湖北长江北斗数字产业有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北长江北斗数字产业有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江北斗数字产业有限公司成立于2023年3月20日，注册资本5亿元，是长江产业投资集团全资子公司，承担着湖北省突破性发展北斗产业、打造湖北北斗企业“航母”的光荣使命，是湖北省北斗行业开展垂直整合、兼并收购的主要平台和战略引擎。公司坚守国企使命担当，兼顾市场化运营路径，紧扣创新驱动主线，遵循产业发展规律，构建完整商业运营闭环。主营业务涵盖北斗数字产业规划咨询、实体产业运营与并购重组、科创项目孵化培育、新型基础设施建设；依托
                “北斗数字 +
                资本运作”“北斗数字+集成创新”协同发展，推动北斗产业、数字经济、人工智能深度融合、特色发展、提质增效。
              </p>
            </div>
          </section>

          <!-- 湖北省长江新动能私募基金管理有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省长江新动能私募基金管理有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江新动能私募基金管理有限公司成立于2022年4月，由湖北省新动能基金管理有限公司、湖北高投产控投资股份有限公司、湖北省长投私募基金管理有限公司共同组建，系长江产业投资集团有限公司全资子公司。作为长江产业集团并购与证券事业功能的重要载体，长江新动能承担湖北省上市公司资本市场基础服务平台职能，负责运营“湖北省上市公司高质量发展促进中心”。公司以服务集团并购与资本运作为核心，业务涵盖上市公司（非上市公司）并购，湖北省上市公司纾困基金、上市公司高质量发展基金及湖北ETF指数基金管理，上市公司定向增发再融资等。目前，公司在管基金规模超过150亿元，已成功主导奥特佳、长江证券、凯龙股份、台基股份等多个上市公司并购项目。
              </p>
              <p>
                长江新动能致力于打造成为放大国有资本功能、优化资本布局、推进资产证券化、开展多元化资本市场业务与上市公司市值管理的核心平台。
              </p>
            </div>
          </section>

          <!-- 湖北长江产业现代化工有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北长江产业现代化工有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产业现代化工有限公司（集团化工事业部）作为集团现代化工版块功能性投资平台，是化工板块的“链长”单位，负责统筹协调化工板块优势资源，推动产业协同发展。聚焦基础化工、精细化工、化工新材料等领域，通过战略并购、企业重组、新增设立等模式，投资控股一批优质化工企业，构建“投资-运营-上市-收益”的产业资本运作闭环，致力成为省内前列、国内一流的现代化工产业投资集团。
              </p>
            </div>
          </section>

          <!-- 湖北省长江新材有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省长江新材有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江新材有限公司（简称“长江新材”）于2022年4月6日揭牌成立，由原湖北省长投环保有限公司与湖北长投联合矿业开发有限公司重组整合而来。公司注册资本10亿元，总资产规模71.07亿元，控股子公司31家，员工256人。
                作为长江产业投资集团的核心子公司，长江新材遵循集团“1+N+1+1”产业投资运营模式，实施“双轮驱动”战略，聚焦产业供应链与新材料两大主业。核心业务涵盖：绿色建材产业投资运营及重大项目保障服务；新材料研发、生产、销售与技术创新；绿色矿山开发、生态修复及矿产资源利用；产业供应链贸易等。
              </p>
              <p>
                面向未来，长江新材将锚定湖北省建设中部地区崛起重要战略支点的目标，紧密对接全省“51020”发展战略，加速推动产业从基础原材料向中高端新材料创新升级。公司目标至2027年，整体营业收入突破350亿元，利润突破3亿元，全面建成全国一流的新材料产业投资运营平台和现代产业供应链综合服务商。长江新材致力于勇当长江产业高质量发展引领者，为长江经济带发展筑基，为支点建设加持，为中国式现代化湖北实践赋能。
              </p>
            </div>
          </section>

          <!-- 湖北省生态环保有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省生态环保有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省生态环保有限公司成立于2017年11月10日，为长江产业投资集团有限公司全资子公司，注册资本金10亿元。公司作为长江产业投资集团有限公司生态环保产业投资建设运营主体，聚焦国家绿色发展战略和湖北省“51020”现代产业集群建设，坚持“投资引领
                创新驱动”，致力于成为以水环境综合治理、危固废综合利用、资源循环利用为特色方向，以现代环保技术和装备为核心支撑，“研投建运服”一体的生态环保综合服务商和全国一流的生态环保产业集团。
              </p>
            </div>
          </section>

          <!-- 湖北省新能源有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省新能源有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省新能源有限公司成立于2022年，是长江产业集团二级子公司，为省属唯一新能源产业投资平台，注册资本金10亿元。公司聚焦风光水储传统产业、复合材料新兴产业、绿氢氨醇未来产业，全力打造全省领先、全国一流的中型综合能源公司，下设售电、运维、新材料等多家专业和区域子公司。现已投产及在建新能源装机规模超1.5GW，储备项目达3GW，分布于湖北、广西、河北、陕西等多个省市。
              </p>
              <p>
                公司积极践行国家“碳达峰、碳中和”战略，以新能源资源开发和新能源装备制造为主业，聚焦风光水储多能互补基地、源网荷储一体化解决方案，布局储能、氢能、新型电池技术、新材料、智慧能源等新型业态，致力于打造以电力资产为基础、能源装备为支撑的新型能源上市公司。近年来，荣获国务院国资委“双百企业”、长江产业集团“先进集体”“五好班子”等多项荣誉。
              </p>
            </div>
          </section>

          <!-- 湖北长江产业载体投资开发有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北长江产业载体投资开发有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产业载体投资开发有限公司（以下简称“长江投开”）系经湖北房地产投资集团有限公司（成立于2009年）改革重组设立，注册资本23亿元。截至2025年12月，公司资产总额达197.97亿元，累计实施开发项目26个，总建筑面积近900万平方米（其中：已交付项目12个，在建项目14个）。
              </p>
              <p>
                长江投开紧紧围绕集团战略部署，定位于产业园区投资、开发、建设主体和产业园区产业开发、培育、发展主体。专注开发产业园区、产融新城、科创基地、双创社区、总部综合体等产业载体，致力成为具备产业载体投资、开发、建设、运营、管理及园区产业投资、培育、发展等功能于一体的综合投融资平台。
              </p>
            </div>
          </section>

          <!-- 湖北省人才发展集团有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省人才发展集团有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省人才发展集团有限公司（简称“湖北省人才集团”）成立于2023年6月25日，由长江产业投资集团在湖北省人力资源和社会保障厅划转企业湖北中新人力资源开发有限公司和湖北省人才市场有限责任公司基础上，聚合旗下人力资源服务优势板块组建而成，现有各类分子公司8家，是湖北省、武汉市人力资源服务诚信示范机构、人力资源服务业领军企业，湖北省第二批服务业“专精特新”企业。
              </p>
              <p>
                作为省委、省政府实施人才强省战略的市场化主抓手，湖北省人才集团在省委组织部、省人社厅的指导下，围绕写好“供需对接、资源整合、成果转化”三篇文章，积极履行全省人才资源整合配置主体和人才服务综合平台功能，以长江人才大厦为核心载体，构建基础人才服务、高端人才服务、股权激励服务、人才创业服务、人才研究咨询“五位一体”的综合人才服务平台，服务全省人才服务体系建设，致力打造成为在全国具有重要影响力的省属国资人才服务平台。
              </p>
            </div>
          </section>

          <!-- 湖北长江产融资本投资有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北长江产融资本投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产融资本投资有限公司（简称“产融资本”）成立于2025年3月，注册资本10亿元，系长江产业集团二级子公司，是集团贯彻落实省政府关于投融资体制改革和“做优做强产业金融平台”决策部署的关键载体。产融资本秉持“金融向实、产融向新”导向，以“全周期服务集团产业、全场景赋能实体企业”为目标，紧密围绕集团“2+3+3+2”国资基金矩阵，将战略资源精准转化为价值倍增动能，重点深耕汽车金融、绿色金融、供应链金融三大领域，致力于构建“租担贷链”联动矩阵，打造中部地区一流的产业金融“生态服务商”。
              </p>
              <p>
                在集团战略与资源精准赋能下，产融资本聚焦“1条主线”（以服务集团产业发展为核心，推动产融深度协同）；用好“2个抓手”（金融工具协同、数智技术赋能）；培育“3大板块”（汽车金融破局、绿色金融布局、供应链金融覆盖）；实现“4项探索”（构筑产业金融生态链、建立科创服务标准化体系、重塑产融服务范式、激活资本运作能级），全面转向“内生式增长、差异化竞争、生态化协同”的高质量发展新范式。围绕“价值创造、协同增效、创新驱动”三大核心，构建具有长江产业特色的金融生态体系。产融资本成立一年以来，累计形成业务资产规模超40亿元，覆盖新能源、生态环保、新材料等领域，服务内外部企业超150户。
              </p>
            </div>
          </section>

          <!-- 湖北长江汽车产业投资有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北长江汽车产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江汽车产业投资有限公司（简称"长江汽车"）是长江产业投资集团旗下汽车与高端装备产业“链长”单位，发挥统筹赋能作用，履行产业研究、战略规划、资本运作、业务协同等核心职能，致力于打造以新型关键零部件制造为主导，向商用车整车和专用车、高端装备、汽车贸易及汽车金融等领域延伸的省内一流现代汽车产业集团。
              </p>
            </div>
          </section>

          <!-- 湖北省长江光电产业投资有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省长江光电产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江光电产业投资有限公司成立于2024年7月，是长江产业集团在战略新兴产业的关键布局，公司专注于光电子信息行业的战略并购和实体运营，承担着支持和服务湖北省突破性发展光电子信息产业、打造世界级产业集群的重要使命。公司始终秉承“产业报国、实业强国”理念，认真践行长江产业集团“1+N+1+1”产业投资运营体系，大力实施“1+3+X”发展战略，围绕集成电路、光通信、激光、新型显示等重点赛道，开展实体并购及运营、产业资源协同、服务平台建设等工作，因地制宜发展光电子信息领域新质生产力。长江光电公司积极履行“链长”企业职责职能，以突破性发展光电子信息产业为使命任务，强化创新链、产业链、资金链、人才链融合，通过生态搭建、产业串联、协同创新等方式赋能产业，整合“政产学研金服用”等资源要素，构筑现代化产业体系，推动产业高质量发展。
              </p>
            </div>
          </section>

          <!-- 湖北省长江医疗产业投资有限公司 -->
          <section class="intro-section sub-company">
            <div class="section-title">
              <h3>湖北省长江医疗产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江医疗产业投资有限公司（简称：长江医投）成立于2023年11月22日，注册资本10亿元人民币，是长江产业集团旗下全资二级子公司，肩负集团生命健康事业部及产业链“链长”的战略使命，以“产业并购及运营+产业基金”双轮驱动为抓手，系统整合集团医药与医疗产业资源，布局医药工业、医药商业及生物医药前沿科技赛道，助力集团加快形成省级医药集团合力，加速推动我省生命健康产业高质量发展。
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div class="intro-mobile" v-show="!isPC">
      <div class="mobile-intro-container">
        <!-- 子公司简介列表 -->
        <div class="sub-company-mobile-list">
          <!-- 深圳万润科技股份有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>深圳万润科技股份有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                深圳万润科技股份有限公司（证券简称：万润科技，证券代码002654）创立于2002年12月，注册地在深圳市光明区，注册资本8.45亿元，于2012年2月在深交所上市，是国企控股、市场化运作的混合所有制上市公司，公司实控人是湖北省国资委，控股股东为长江产业投资集团。
              </p>
              <p>
                公司早期主要从事LED光源器件封装和LED照明灯具制造，上市后，通过收并购，进入标识照明、照明工程、综合能源管理和新能源、广告传媒等业务。现LED业务已形成集封装-照明-合同能源管理-照明工程设计与施工-智慧城市为一体的中下游产业链协同配套布局，是国内领先的集研发、设计、生产、销售、照明工程设计与施工于一体的综合服务商，聚焦差异化的中高端市场和产品，业务遍布全球主要国家和地区。2022年，公司正式进入半导体存储产业，逐步完善集研发设计、生产测试和销售服务于一体的产业链布局，形成了覆盖消费级、工业级、企业级的存储产品矩阵，为新一代信息技术产业发展奠定坚实基础。
                未来，公司将大力发展以LED、半导体存储为核心的新一代信息技术“主产业”，培育综合能源服务“副产业”，使公司成为新一代信息技术领域具有行业影响力的科技型创新型上市公司。
              </p>
            </div>
          </section>

          <!-- 湖北长江北斗数字产业有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北长江北斗数字产业有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江北斗数字产业有限公司成立于2023年3月20日，注册资本5亿元，是长江产业投资集团全资子公司，承担着湖北省突破性发展北斗产业、打造湖北北斗企业“航母”的光荣使命，是湖北省北斗行业开展垂直整合、兼并收购的主要平台和战略引擎。公司坚守国企使命担当，兼顾市场化运营路径，紧扣创新驱动主线，遵循产业发展规律，构建完整商业运营闭环。主营业务涵盖北斗数字产业规划咨询、实体产业运营与并购重组、科创项目孵化培育、新型基础设施建设；依托
                “北斗数字 +
                资本运作”“北斗数字+集成创新”协同发展，推动北斗产业、数字经济、人工智能深度融合、特色发展、提质增效。
              </p>
            </div>
          </section>

          <!-- 湖北省长江新动能私募基金管理有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省长江新动能私募基金管理有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江新动能私募基金管理有限公司成立于2022年4月，由湖北省新动能基金管理有限公司、湖北高投产控投资股份有限公司、湖北省长投私募基金管理有限公司共同组建，系长江产业投资集团有限公司全资子公司。作为长江产业集团并购与证券事业功能的重要载体，长江新动能承担湖北省上市公司资本市场基础服务平台职能，负责运营“湖北省上市公司高质量发展促进中心”。公司以服务集团并购与资本运作为核心，业务涵盖上市公司（非上市公司）并购，湖北省上市公司纾困基金、上市公司高质量发展基金及湖北ETF指数基金管理，上市公司定向增发再融资等。目前，公司在管基金规模超过150亿元，已成功主导奥特佳、长江证券、凯龙股份、台基股份等多个上市公司并购项目。
              </p>
              <p>
                长江新动能致力于打造成为放大国有资本功能、优化资本布局、推进资产证券化、开展多元化资本市场业务与上市公司市值管理的核心平台。
              </p>
            </div>
          </section>

          <!-- 湖北长江产业现代化工有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北长江产业现代化工有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产业现代化工有限公司（集团化工事业部）作为集团现代化工版块功能性投资平台，是化工板块的“链长”单位，负责统筹协调化工板块优势资源，推动产业协同发展。聚焦基础化工、精细化工、化工新材料等领域，通过战略并购、企业重组、新增设立等模式，投资控股一批优质化工企业，构建“投资-运营-上市-收益”的产业资本运作闭环，致力成为省内前列、国内一流的现代化工产业投资集团。
              </p>
            </div>
          </section>

          <!-- 湖北省长江新材有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省长江新材有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江新材有限公司（简称“长江新材”）于2022年4月6日揭牌成立，由原湖北省长投环保有限公司与湖北长投联合矿业开发有限公司重组整合而来。公司注册资本10亿元，总资产规模71.07亿元，控股子公司31家，员工256人。
                作为长江产业投资集团的核心子公司，长江新材遵循集团“1+N+1+1”产业投资运营模式，实施“双轮驱动”战略，聚焦产业供应链与新材料两大主业。核心业务涵盖：绿色建材产业投资运营及重大项目保障服务；新材料研发、生产、销售与技术创新；绿色矿山开发、生态修复及矿产资源利用；产业供应链贸易等。
              </p>
              <p>
                面向未来，长江新材将锚定湖北省建设中部地区崛起重要战略支点的目标，紧密对接全省“51020”发展战略，加速推动产业从基础原材料向中高端新材料创新升级。公司目标至2027年，整体营业收入突破350亿元，利润突破3亿元，全面建成全国一流的新材料产业投资运营平台和现代产业供应链综合服务商。长江新材致力于勇当长江产业高质量发展引领者，为长江经济带发展筑基，为支点建设加持，为中国式现代化湖北实践赋能。
              </p>
            </div>
          </section>

          <!-- 湖北省生态环保有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省生态环保有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省生态环保有限公司成立于2017年11月10日，为长江产业投资集团有限公司全资子公司，注册资本金10亿元。公司作为长江产业投资集团有限公司生态环保产业投资建设运营主体，聚焦国家绿色发展战略和湖北省“51020”现代产业集群建设，坚持“投资引领
                创新驱动”，致力于成为以水环境综合治理、危固废综合利用、资源循环利用为特色方向，以现代环保技术和装备为核心支撑，“研投建运服”一体的生态环保综合服务商和全国一流的生态环保产业集团。
              </p>
            </div>
          </section>

          <!-- 湖北省新能源有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省新能源有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省新能源有限公司成立于2022年，是长江产业集团二级子公司，为省属唯一新能源产业投资平台，注册资本金10亿元。公司聚焦风光水储传统产业、复合材料新兴产业、绿氢氨醇未来产业，全力打造全省领先、全国一流的中型综合能源公司，下设售电、运维、新材料等多家专业和区域子公司。现已投产及在建新能源装机规模超1.5GW，储备项目达3GW，分布于湖北、广西、河北、陕西等多个省市。
              </p>
              <p>
                公司积极践行国家“碳达峰、碳中和”战略，以新能源资源开发和新能源装备制造为主业，聚焦风光水储多能互补基地、源网荷储一体化解决方案，布局储能、氢能、新型电池技术、新材料、智慧能源等新型业态，致力于打造以电力资产为基础、能源装备为支撑的新型能源上市公司。近年来，荣获国务院国资委“双百企业”、长江产业集团“先进集体”“五好班子”等多项荣誉。
              </p>
            </div>
          </section>

          <!-- 湖北长江产业载体投资开发有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北长江产业载体投资开发有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产业载体投资开发有限公司（以下简称“长江投开”）系经湖北房地产投资集团有限公司（成立于2009年）改革重组设立，注册资本23亿元。截至2025年12月，公司资产总额达197.97亿元，累计实施开发项目26个，总建筑面积近900万平方米（其中：已交付项目12个，在建项目14个）。
              </p>
              <p>
                长江投开紧紧围绕集团战略部署，定位于产业园区投资、开发、建设主体和产业园区产业开发、培育、发展主体。专注开发产业园区、产融新城、科创基地、双创社区、总部综合体等产业载体，致力成为具备产业载体投资、开发、建设、运营、管理及园区产业投资、培育、发展等功能于一体的综合投融资平台。
              </p>
            </div>
          </section>

          <!-- 湖北省人才发展集团有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省人才发展集团有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省人才发展集团有限公司（简称“湖北省人才集团”）成立于2023年6月25日，由长江产业投资集团在湖北省人力资源和社会保障厅划转企业湖北中新人力资源开发有限公司和湖北省人才市场有限责任公司基础上，聚合旗下人力资源服务优势板块组建而成，现有各类分子公司8家，是湖北省、武汉市人力资源服务诚信示范机构、人力资源服务业领军企业，湖北省第二批服务业“专精特新”企业。
              </p>
              <p>
                作为省委、省政府实施人才强省战略的市场化主抓手，湖北省人才集团在省委组织部、省人社厅的指导下，围绕写好“供需对接、资源整合、成果转化”三篇文章，积极履行全省人才资源整合配置主体和人才服务综合平台功能，以长江人才大厦为核心载体，构建基础人才服务、高端人才服务、股权激励服务、人才创业服务、人才研究咨询“五位一体”的综合人才服务平台，服务全省人才服务体系建设，致力打造成为在全国具有重要影响力的省属国资人才服务平台。
              </p>
            </div>
          </section>

          <!-- 湖北长江产融资本投资有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北长江产融资本投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江产融资本投资有限公司（简称“产融资本”）成立于2025年3月，注册资本10亿元，系长江产业集团二级子公司，是集团贯彻落实省政府关于投融资体制改革和“做优做强产业金融平台”决策部署的关键载体。产融资本秉持“金融向实、产融向新”导向，以“全周期服务集团产业、全场景赋能实体企业”为目标，紧密围绕集团“2+3+3+2”国资基金矩阵，将战略资源精准转化为价值倍增动能，重点深耕汽车金融、绿色金融、供应链金融三大领域，致力于构建“租担贷链”联动矩阵，打造中部地区一流的产业金融“生态服务商”。
              </p>
              <p>
                在集团战略与资源精准赋能下，产融资本聚焦“1条主线”（以服务集团产业发展为核心，推动产融深度协同）；用好“2个抓手”（金融工具协同、数智技术赋能）；培育“3大板块”（汽车金融破局、绿色金融布局、供应链金融覆盖）；实现“4项探索”（构筑产业金融生态链、建立科创服务标准化体系、重塑产融服务范式、激活资本运作能级），全面转向“内生式增长、差异化竞争、生态化协同”的高质量发展新范式。围绕“价值创造、协同增效、创新驱动”三大核心，构建具有长江产业特色的金融生态体系。产融资本成立一年以来，累计形成业务资产规模超40亿元，覆盖新能源、生态环保、新材料等领域，服务内外部企业超150户。
              </p>
            </div>
          </section>

          <!-- 湖北长江汽车产业投资有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北长江汽车产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北长江汽车产业投资有限公司（简称"长江汽车"）是长江产业投资集团旗下汽车与高端装备产业“链长”单位，发挥统筹赋能作用，履行产业研究、战略规划、资本运作、业务协同等核心职能，致力于打造以新型关键零部件制造为主导，向商用车整车和专用车、高端装备、汽车贸易及汽车金融等领域延伸的省内一流现代汽车产业集团。
              </p>
            </div>
          </section>

          <!-- 湖北省长江光电产业投资有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省长江光电产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江光电产业投资有限公司成立于2024年7月，是长江产业集团在战略新兴产业的关键布局，公司专注于光电子信息行业的战略并购和实体运营，承担着支持和服务湖北省突破性发展光电子信息产业、打造世界级产业集群的重要使命。公司始终秉承“产业报国、实业强国”理念，认真践行长江产业集团“1+N+1+1”产业投资运营体系，大力实施“1+3+X”发展战略，围绕集成电路、光通信、激光、新型显示等重点赛道，开展实体并购及运营、产业资源协同、服务平台建设等工作，因地制宜发展光电子信息领域新质生产力。长江光电公司积极履行“链长”企业职责职能，以突破性发展光电子信息产业为使命任务，强化创新链、产业链、资金链、人才链融合，通过生态搭建、产业串联、协同创新等方式赋能产业，整合“政产学研金服用”等资源要素，构筑现代化产业体系，推动产业高质量发展。
              </p>
            </div>
          </section>

          <!-- 湖北省长江医疗产业投资有限公司 -->
          <section class="intro-section mobile-section sub-company">
            <div class="section-title">
              <h3>湖北省长江医疗产业投资有限公司</h3>
            </div>
            <div class="section-content">
              <p>
                湖北省长江医疗产业投资有限公司（简称：长江医投）成立于2023年11月22日，注册资本10亿元人民币，是长江产业集团旗下全资二级子公司，肩负集团生命健康事业部及产业链“链长”的战略使命，以“产业并购及运营+产业基金”双轮驱动为抓手，系统整合集团医药与医疗产业资源，布局医药工业、医药商业及生物医药前沿科技赛道，助力集团加快形成省级医药集团合力，加速推动我省生命健康产业高质量发展。
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabIntro",
  data() {
    return {
      isPC: true,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      // 移动端阈值：992px
      this.isPC = window.innerWidth >= 992;
    },
  },
};
</script>
<style scoped lang="less">
.intro-page {
  width: 100%;
  padding: 20px 0;
  background-color: #f9f9f9;
}
// PC端样式
.intro-pc {
  .company-intro-container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 30px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    .intro-section {
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
      .section-title {
        text-align: center;
        margin-bottom: 20px;
        position: relative;
        h3 {
          font-size: 22px;
          color: #006699;
          margin: 0 0 8px;
          position: relative;
          // &::after {
          //     content: '';
          //     display: block;
          //     width: 50px;
          //     height: 3px;
          //     background: #0099cc;
          //     margin: 8px auto 0;
          // }
        }
        .en-title {
          font-size: 14px;
          color: #999;
          text-transform: uppercase;
        }
      }
      .section-content {
        line-height: 1.8;
        font-size: 16px;
        color: #333;
        text-align: justify;
        p {
          text-indent: 2em;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    /* PC改为单列，每个子公司独立一排 */
    .sub-company-list {
      display: grid;
      grid-template-columns: 1fr;
      gap: 30px;
      .sub-company {
        margin-bottom: 0;
        padding: 20px;
        background: #f5f8fa;
        border-radius: 6px;
        .section-content {
          font-size: 15px;
        }
      }
    }
  }
}
// 移动端样式
.intro-mobile {
  .mobile-intro-container {
    width: 95%;
    margin: 0 auto;
    background: #fff;
    padding: 20px 15px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    .mobile-section {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .section-title {
        text-align: center;
        margin-bottom: 15px;
        h3 {
          font-size: 18px;
          color: #006699;
          margin: 0 0 6px;
          // &::after {
          //     content: '';
          //     display: block;
          //     width: 40px;
          //     height: 2px;
          //     background: #0099cc;
          //     margin: 6px auto 0;
          // }
        }
        .en-title {
          font-size: 12px;
          color: #999;
        }
      }
      .section-content {
        line-height: 1.7;
        font-size: 14px;
        color: #333;
        text-align: justify; // 中间行两端对齐
        p {
          text-indent: 2em; // 保留首行缩进，和公告统一
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .sub-company {
        background: #f5f8fa;
        padding: 15px;
        border-radius: 4px;
      }
    }
  }
}
// 响应式显隐
@media screen and (max-width: 991px) {
  .intro-pc {
    display: none !important;
  }
}
@media screen and (min-width: 992px) {
  .intro-mobile {
    display: none !important;
  }
}
</style>